import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { mediaUrl } from "@/lib/api";
import { ZAR } from "@/lib/cart";

export default function FrequentlyBoughtWith({ slug }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get(`/products/${slug}/related`).then((r) => setItems(r.data)).catch(() => {});
  }, [slug]);
  if (items.length === 0) return null;
  return (
    <section className="mt-20" data-testid="frequently-bought">
      <div className="font-label text-xs text-[#00FFC2]">/ FREQUENTLY BOUGHT WITH</div>
      <h2 className="mt-3 font-display text-3xl font-black tracking-tighter">
        Pair it <span className="text-white/50">with…</span>
      </h2>
      <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {items.map((p) => (
          <Link
            key={p.slug}
            to={`/product/${p.slug}`}
            className="group border border-white/10 bg-[#0d0d0d] overflow-hidden hover:border-white/25 transition-colors"
          >
            <div className="aspect-[4/5] overflow-hidden bg-black">
              {p.images?.[0] && (
                <img
                  src={mediaUrl(p.images[0])}
                  alt=""
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              )}
            </div>
            <div className="p-4">
              <div className="font-label text-[10px] text-white/40">{p.brand}</div>
              <div className="mt-1 font-display text-sm font-bold line-clamp-1">{p.name}</div>
              <div className="mt-2 font-display font-bold text-[#00FFC2]">{ZAR(p.price)}</div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
